export const DETECT_TOUCH = 'general/DETECT_TOUCH';
export const ADD_CONFIGURATIONS = 'general/ADD_CONFIGURATIONS';
export const LOADING_CONFIGURATIONS = 'general/LOADING_CONFIGURATIONS';
export const ADD_NOTIFICATION = 'general/ADD_NOTIFICATION';
export const DELETE_NOTIFICATION = 'general/DELETE_NOTIFICATION';
